export interface SharedFile {
    id: string;
    blob: Blob;
    name: string;
    type: string;
    lastModified?: number;
    thumbnails: string[];
}

export enum ShareAction {
    CreateExpense,
    UpdateExpense,
}
